// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';

import CheckBoxGroup from '../CheckBoxGroup';
import { availableCarTypesList } from 'Common/filterValues';

// Helpers
import classNames from 'classnames';

/**
 * <AdvancedFiltersResults /> component.
 * @return {class} returns BasicFiltersMultiSelect instance
 */
class AdvancedFiltersResults extends PureComponent<*, *> {
  /**
   * componentDidMount
   * @return {void}
   */
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('click', this.props.closeSwoosh);
  }

  /**
   * componentWillUnmount
   * @return {void}
   */
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('click', this.props.closeSwoosh);
  }

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - styles.
   * @prop {object} fields - fields.
   * @prop {array} models - models.
   * @prop {number} priceFrom - priceFrom.
   * @prop {number} priceTo - priceTo.
   * @prop {function} checkPostcode - checkPostcode.
   * @prop {boolean} isPostcodeValid - isPostcodeValid.
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    fields: PropTypes.object,
    resetField: PropTypes.func,
    additonalOptions: PropTypes.object,
    resultsLength: PropTypes.number,
    isLeasingPage: PropTypes.bool,
    isStockCarsPage: PropTypes.bool
  };

  /**
   * Renders <BasicFilters /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render(): Node {
    // Getting props
    const {
      styles,
      fields,
      resetField,
      isMobile,
      setAsSelected,
      currentSelection,
      isLeasingPage,
      isStockCarsPage
    } = this.props;

    // Getting additionalOptions from props
    const {
      transmissions,
      fuelTypes,
      category,
      colours,
      doors,
      seats,
      mileages,
      standardDrivetrain,
      insuranceGroup,
      yearFrom,
      yearTo,
      engineSizeFrom,
      engineSizeTo
    } = this.props.additonalOptions;

    return (
      <div>
        <div className={classNames(styles.advancedFilterContainer)}>
          <CheckBoxGroup
            styles={styles}
            name={'standardDrivetrain'}
            label={'Drive type'}
            selectedValue={fields.standardDrivetrain}
            options={standardDrivetrain}
            isSelected={currentSelection === 'standardDrivetrain'}
            onSelect={() => setAsSelected('standardDrivetrain')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('standardDrivetrain')}
            disableFiltering={true}
            isMobile={isMobile}
          />
          <CheckBoxGroup
            styles={styles}
            name={'category'}
            label={'Body type'}
            selectedValue={fields.category}
            options={category.filter(item =>
              availableCarTypesList.includes(item.key)
            )}
            isSelected={currentSelection === 'category'}
            onSelect={() => setAsSelected('category')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('category')}
            disableFiltering={true}
            isCarTypes={true}
            isMobile={isMobile}
          />
          <CheckBoxGroup
            styles={styles}
            name={'fuelType'}
            label={'Fuel type'}
            selectedValue={fields.fuelType}
            options={fuelTypes}
            isSelected={currentSelection === 'fuelType'}
            onSelect={() => setAsSelected('fuelType')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('fuelType')}
            disableFiltering={true}
            isMobile={isMobile}
          />
          <CheckBoxGroup
            styles={styles}
            name={'gearBox'}
            label={'Gearbox'}
            selectedValue={fields.gearBox}
            options={transmissions}
            isSelected={currentSelection === 'gearBox'}
            onSelect={() => setAsSelected('gearBox')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('gearBox')}
            disableFiltering={true}
            isMobile={isMobile}
          />
          {!isLeasingPage && !isStockCarsPage && (
            <div>
              <CheckBoxGroup
                styles={styles}
                name={'yearFrom'}
                label={'Year from'}
                selectedValue={fields.yearFrom}
                options={yearFrom}
                isSelected={currentSelection === 'yearFrom'}
                onSelect={() => setAsSelected('yearFrom')}
                onClose={() => setAsSelected(null)}
                setAsSelected={setAsSelected}
                resetField={() => resetField('yearFrom')}
                isSwoosh={true}
                isMobile={isMobile}
              />
              <CheckBoxGroup
                styles={styles}
                name={'yearTo'}
                label={'Year to'}
                selectedValue={fields.yearTo}
                options={yearTo}
                isSelected={currentSelection === 'yearTo'}
                onSelect={() => setAsSelected('yearTo')}
                onClose={() => setAsSelected(null)}
                setAsSelected={setAsSelected}
                resetField={() => resetField('yearTo')}
                isSwoosh={true}
                isMobile={isMobile}
              />
            </div>
          )}
          {!isLeasingPage && !isStockCarsPage && (
            <CheckBoxGroup
              styles={styles}
              name={'mileage'}
              label={'Mileage'}
              selectedValue={fields.mileage}
              options={mileages}
              isSelected={currentSelection === 'mileage'}
              onSelect={() => setAsSelected('mileage')}
              onClose={() => setAsSelected(null)}
              setAsSelected={setAsSelected}
              resetField={() => resetField('mileage')}
              isSwoosh={true}
              isMobile={isMobile}
            />
          )}
          {!isLeasingPage && (
            <CheckBoxGroup
              styles={styles}
              name={'insuranceGroup'}
              label={'Insurance group'}
              selectedValue={fields.insuranceGroup}
              options={insuranceGroup}
              isSelected={currentSelection === 'insuranceGroup'}
              onSelect={() => setAsSelected('insuranceGroup')}
              onClose={() => setAsSelected(null)}
              setAsSelected={setAsSelected}
              resetField={() => resetField('insuranceGroup')}
              disableFiltering={true}
              isMobile={isMobile}
            />
          )}
          <CheckBoxGroup
            styles={styles}
            name={'colour'}
            label={'Colour'}
            selectedValue={fields.colour}
            options={colours}
            isSelected={currentSelection === 'colour'}
            onSelect={() => setAsSelected('colour')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('colour')}
            isSwoosh={true}
            isMobile={isMobile}
          />
          <CheckBoxGroup
            styles={styles}
            name={'doors'}
            label={'Doors'}
            selectedValue={fields.doors}
            options={doors}
            isSelected={currentSelection === 'doors'}
            onSelect={() => setAsSelected('doors')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('doors')}
            disableFiltering={true}
            isMobile={isMobile}
          />
          <CheckBoxGroup
            styles={styles}
            name={'seats'}
            label={'Seats'}
            selectedValue={fields.seats}
            options={seats}
            isSelected={currentSelection === 'seats'}
            onSelect={() => setAsSelected('seats')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('seats')}
            isSwoosh={true}
            isMobile={isMobile}
          />
          <CheckBoxGroup
            styles={styles}
            name={'engineSizeFrom'}
            label={'Engine size from'}
            selectedValue={fields.engineSizeFrom}
            options={engineSizeFrom}
            isSelected={currentSelection === 'engineSizeFrom'}
            onSelect={() => setAsSelected('engineSizeFrom')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('engineSizeFrom')}
            isSwoosh={true}
            isMobile={isMobile}
          />
          <CheckBoxGroup
            styles={styles}
            name={'engineSizeTo'}
            label={'Engine size to'}
            selectedValue={fields.engineSizeTo}
            options={engineSizeTo}
            isSelected={currentSelection === 'engineSizeTo'}
            onSelect={() => setAsSelected('engineSizeTo')}
            onClose={() => setAsSelected(null)}
            setAsSelected={setAsSelected}
            resetField={() => resetField('engineSizeTo')}
            isSwoosh={true}
            isMobile={isMobile}
          />
        </div>
      </div>
    );
  }
}

export default AdvancedFiltersResults;



// WEBPACK FOOTER //
// ./src/Common/AdvancedFiltersResults/index.js